export const endingViewpoints = [
  {
    id: "ending-1",
    icon: "ri-question-line",
    title: "纲吉到底有没有继承十代目？",
    status: "作品有明确交代",
    desc: "关于这个问题，作品本身给出的信息是相对清楚的，但在读者之间仍常有讨论。需要注意的是，区分「剧情里已经发生的事」和「读者希望发生的事」很重要。本站只呈现剧情层面的结论，不对人物未来做额外延伸。",
  },
  {
    id: "ending-2",
    icon: "ri-emotion-happy-line",
    title: "结局是圆满还是遗憾？",
    status: "观众解读差异最大",
    desc: "有人觉得故事回到了温暖的日常，是圆满；也有人觉得战斗结束得太过仓促，留有遗憾。这两种感受都成立，因为它们衡量的是不同的东西：一个是情感的落点，一个是叙事的节奏。",
  },
  {
    id: "ending-3",
    icon: "ri-user-follow-line",
    title: "里包恩最后留下了什么？",
    status: "需要结合全篇理解",
    desc: "里包恩的存在感几乎贯穿全篇。与其盯着他最后的处境，不如回看他一路做了什么——作为家庭教师，他的任务是把纲吉培养成能独自站立的人，这一点是否完成，决定了这个角色的收束是否成立。",
  },
  {
    id: "ending-4",
    icon: "ri-tv-2-line",
    title: "动画结局与漫画结局为何不同？",
    status: "制作进度差异",
    desc: "电视动画在 2010 年完结，覆盖的主要篇章止于彩虹之子相关部分；漫画则继续连载到后续篇章，并给出了作品的正式结尾。两者并不矛盾，只是覆盖范围不同，这解释了为什么不同观众的「结局印象」会不一样。",
  },
  {
    id: "ending-5",
    icon: "ri-chat-smile-2-line",
    title: "为什么关于结局的争论一直存在？",
    status: "开放式收尾",
    desc: "作品在收尾时保留了一定的开放感，没有把所有枝节都绑得严丝合缝。对追求确定感的观众来说，这容易产生「没讲完」的感觉；对偏好余韵的观众来说，这种留白恰恰是它的魅力所在。",
  },
  {
    id: "ending-6",
    icon: "ri-star-smile-line",
    title: "值得为了结局补完整部作品吗？",
    status: "建议从头看",
    desc: "如果你是因为好奇结局才接触这部作品，直接跳到结尾反而会失掉大部分乐趣。它的价值更多在于过程的积累：角色怎么一步步变成现在的样子。理解了过程，结局才有分量。",
  },
];